import { render } from "./InactiveMessage.vue?vue&type=template&id=3246e1f6"
import script from "./InactiveMessage.vue?vue&type=script&lang=js"
export * from "./InactiveMessage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TEMP\\Website_Corneel\\luisterlive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__